import { gql } from "__generated__/gql";
import { useQuery } from "utils/apollo/hooks";
import { useCurrentUserData } from "utils/currentUserHooks";
import { useGetRouteParam } from "utils/routeParamHooks";

const currentBrokerQuery = gql(/* GraphQL */ `
  query CurrentBroker($slug: String!) {
    broker: brokerBySlug(slug: $slug) {
      id
      name
      slug
      ...BrokerAccountMenuItem
      ...BrokerAdminNavCurrentBroker
    }
  }
`);

export function useCurrentBrokerSlug() {
  return useGetRouteParam("brokerSlug");
}

export function useCurrentBroker() {
  const brokerSlug = useCurrentBrokerSlug();
  const user = useCurrentUserData();

  const { data } = useQuery(currentBrokerQuery, {
    skip: !brokerSlug || !user,
    variables: brokerSlug ? { slug: brokerSlug } : undefined,
    returnPartialData: true,
  });

  return data?.broker;
}

export function useCurrentBrokerId() {
  const currentBroker = useCurrentBroker();
  return currentBroker?.id;
}
